import angular from 'angular';

angular.module('cloudX').directive('cxInvoiceExpiryDate', function() {
  return {
    restrict: 'E',
    replace: true,
    bindToController: {
      onbeforesave: '&',
      onaftersave: '&',
    },
    template: `<div>
                  <div class="margin5B">
                    <cx-enum-select data="ctrl.value.expiryType"
                    type="invoiceExpiryType"
                    save="ctrl.submit(newValue, 'expiryType')"
                    placeholder="'Use company setting'|translate"
                    show-placeholder-if-null="true"></cx-enum-select>
                  </div>
                  <div ng-show="(!!ctrl.value.expiryType || ctrl.value.expiryType===0) && ctrl.value.expiryType!==2" class="margin5B">
                    <a editable-number="ctrl.value.expiryDays"
                    blur="submit"
                    e-min="0"
                    e-max="200"
                    e-style="width:80px;"
                    e-inputgroupright="('days'|translate)"
                    onbeforesave="ctrl.submit($data, 'expiryDays')">
                      {{ctrl.value.expiryDays || 0}}
                      <span data-translate>days</span>
                    </a>
                  </div>
                </div>`,
    require: ['ngModel', 'cxInvoiceExpiryDate'],
    link: function(scope, el, attrs, ctrl) {
      if (!ctrl || ctrl.length !== 2) return;
      var ngModel = ctrl[0];
      var controller = ctrl[1];

      controller.view2model = function(value) {
        ngModel.$setViewValue(value);
      };

      // when angular detects a change to the model,
      // we update our inner value
      ngModel.$render = function() {
        controller.setValue(ngModel.$viewValue);
      };
    },
    controllerAs: 'ctrl',
    controller: [
      '$q',
      function($q) {
        const ctrl = this;

        ctrl.setValue = function(value) {
          ctrl.value = angular.extend(
            {
              expiryDays: null,
              expiryType: null,
            },
            ctrl.value,
            value,
          );
        };
        ctrl.setValue(null);
        ctrl.submit = function($data, field) {
          if (ctrl.value && ctrl.value[field] === $data) return false;

          const value = angular.copy(ctrl.value);
          value[field] = $data;

          return $q
            .when(
              ctrl.onbeforesave({
                $data: value,
              }),
            )
            .then(function(result) {
              if (typeof result === 'string') return result;
              if (result !== false) {
                //Update model
                if (ctrl.view2model) {
                  ctrl.view2model(value);
                }
              }
              ctrl.onaftersave({
                $data: value,
              });
              return result;
            });
        };
      },
    ],
  };
});
